import Styles from './AvailableJobs.module.scss';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

//components
import { JobCard } from 'components/global/JobCard/JobCard';




//mui modules
import Slider from '@mui/material/Slider';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import Pagination from '@mui/material/Pagination';



export function AvailableJobs() {

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [experience, setExperience] = useState([0, 30]);
    const [tech, setTech] = useState([]);
    const [jobType, setJobType] = useState('');
    const [searchData, setSearchData] = useState('');
    const [totalPages, setTotalPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);
    const minDistance = 1;
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            try {
                const response = await axios.get(`/api/hiring/job/posting/?page=${pageNumber}`);
                setTotalPages(response.data.data.total)
                setData(response.data.data.data)
                setLoading(false)
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNumber]);



    const handleChange2 = (event, newValue, activeThumb) => {
        if (!Array.isArray(newValue)) {
            return;
        }

        if (newValue[1] - newValue[0] < minDistance) {
            if (activeThumb === 0) {
                const clamped = Math.min(newValue[0], 100 - minDistance);
                setExperience([clamped, clamped + minDistance]);
            } else {
                const clamped = Math.max(newValue[1], minDistance);
                setExperience([clamped - minDistance, clamped]);
            }
        } else {
            setExperience(newValue);
        }
    };

    const names = [
        'Python',
        'Testing',
        'selenium',
        'Playwright',
        'Linux',
        'Java'

    ];

    function handleTechSelect(event) {
        const value = event.target.value
        setTech(value)
    }

    const handleJobTypeSelect = (e) => {
        setJobType(e.target.value);
    };


    function searchLab() {

        axios.get(`/api/hiring/job/posting/?&search=${searchData}&workPreference=${jobType}&minExperience=${experience[0]}&maxExperience=${experience[1]}&techPreferred=${[tech]}`)
            .then(response => {
                // Handle the successful response here
                setData(response.data.data.data)
            })
            .catch(error => {
                // Handle errors here
                console.error('Error:', error);
            });
    }

    const handlePageChange = (event, value) => {
        setPageNumber(value);
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Pagination sx={{ marginLeft: 'auto' }} count={totalPages} color="primary" variant='outlined' onChange={handlePageChange} />
            {!loading &&
                <div className={Styles.mainContainer}>

                    {data.length !== 0 ? <div className={Styles.jobContainer}>
                        {data?.map((job, index) => {
                            return (
                                <JobCard
                                    key={index + 'job'}
                                    data={job}
                                    callback={() => { navigate(`/hiring/jobs/${job?.id}/available`); }}
                                />
                            )
                        })}
                    </div> : <p className={Styles.jobContainer}>No Jobs Present</p>}
                    <div className={Styles.filterContainer}>
                        <div className={Styles.filterHead}>
                            <p >FILTER</p>
                            <p className={Styles.clearFilter} style={{color:'darkgreen'}} onClick={searchLab}>Apply filters</p>
                            <p className={Styles.clearFilter} onClick={()=>{window.location.reload();}}>Clear filters</p>
                        </div>
                        <div className={Styles.searchContainer}>
                            <p>Search </p>
                            <input type='text' placeholder='Search Jobs' className={Styles.search} onChange={(e) => { setSearchData(e.target.value) }} />
                        </div>
                        <div className={Styles.searchContainer}>
                            <p style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>Experience <span className={Styles.expCount}>{experience[0]}-{experience[1]} years</span></p>
                            <Slider
                                value={experience}
                                onChange={handleChange2}
                                max={30}
                                valueLabelDisplay="auto"
                                disableSwap
                                sx={{ color: "black" }}
                            />
                        </div>
                        <div className={Styles.searchContainer}>
                            <p >Work preference</p>
                            <div className={Styles.typeRadio}>
                                <label className={Styles.typeLabel}>
                                    <input type='radio' name='job_type' id='Part-Time' value='Part-Time' onChange={handleJobTypeSelect} />
                                    Part-Time
                                </label>
                                <label className={Styles.typeLabel}>
                                    <input type='radio' name='job_type' id='Full-Time' value='Full-Time' onChange={handleJobTypeSelect} />
                                    Full-Time
                                </label>
                                <label className={Styles.typeLabel}>
                                    <input type='radio' name='job_type' id='Contract' value='Contract' onChange={handleJobTypeSelect} />
                                    Contract
                                </label>
                                <label className={Styles.typeLabel}>
                                    <input type='radio' name='job_type' id='Internship' value='Internship' onChange={handleJobTypeSelect} />
                                    Internship
                                </label>
                            </div>
                        </div>

                        <div className={Styles.searchContainer} style={{ borderBottom: 'none' }}>
                            <p>Tech preferred</p>
                            <Select
                                sx={{ mt: "1rem", borderRadius: '8px' }}
                                fullWidth
                                displayEmpty
                                placeholder='Select Tech'
                                multiple
                                value={tech}
                                onChange={handleTechSelect}
                                renderValue={(selected) => {
                                    if (selected.length === 0) {
                                        return <em>Filter by tech required</em>
                                    } else {
                                        return (
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                                                {selected.map((value) => (
                                                    <Chip key={value} label={value} />
                                                ))}
                                            </div>
                                        )
                                    }
                                }}
                            >

                                {names.map((name) => (
                                    <MenuItem
                                        key={name}
                                        value={name}
                                    // style={getStyles(name, personName, theme)}
                                    >
                                        {name}
                                    </MenuItem>
                                ))}
                            </Select>

                        </div>


                    </div>
                </div>}
        </div>
    )
}